import React from "react";
import { Form } from "react-bootstrap";

const TextAreaField = props => {
  const {
    label,
    className,
    formData,
    isRequiredField,
    onChange,
    placeholder,
    showRequiredError,
    bucketId
  } = props;
  return (
    <Form.Group className={`${className} textAreaField`}>
      <Form.Label>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      <Form.Control
        as="textarea"
        rows="3"
        className={`${
          showRequiredError && formData === "" ? "is-invalid" : ""
        }`}
        value={formData}
        onChange={event => onChange(event, bucketId)}
        placeholder={placeholder}
      />
      {showRequiredError === true && formData === "" ? (
        <Form.Control.Feedback type="invalid">
          This field is required.
        </Form.Control.Feedback>
      ) : (
        <></>
      )}
    </Form.Group>
  );
};
export default TextAreaField;
